/*
 *
 * Estas librerias estan presentes tanto en la website como en el dashboard
 *
 */

//Librerias necesarias
import VeeValidate, { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import Datetime from 'vue-datetime';
import vSelect from 'vue-select';
import vueTopprogress from 'vue-top-progress';
//import '@fortawesome/fontawesome-free/js/all.js';
import Vue2Editor from "vue2-editor";
import VModal from 'vue-js-modal';
import VueCurrencyInput from 'vue-currency-input';
import * as VueGoogleMaps from 'vue2-google-maps';
import BootstrapVue from 'bootstrap-vue';
//Funcion para añadirlas a Vue
function fire(Vue){
	//Vee-validate
	Validator.localize('es', es);
	Vue.use(VeeValidate,{locale:"es"});
	//vue-datetime
	Vue.use(Datetime);
	//Vue-select
	Vue.component('v-select', vSelect);
	//Loading bar
	Vue.use(vueTopprogress);
	//vue2Editor
	Vue.use(Vue2Editor);
	Vue.use(VModal);
	Vue.use(VueCurrencyInput,
		{
		  /* see config reference */
		  globalOptions: { currency: 'MXN', locale: 'es-mx', allowNegative: false }
		}
	);
	//Google map
	Vue.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyAYBEZUWUw3xAWW22zyxtbXCR--cSXoXJQ',
		   libraries: 'places,geometry', // This is required if you use the Autocomplete plugin
				   // OR: libraries: 'places,drawing'
				   // OR: libraries: 'places,drawing,visualization'
				   // (as you require)
	   },
	   installComponents: true,
   });
   Vue.use(BootstrapVue);
}



// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default fire;
